import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { lighten } from 'polished';
import { defineMessage, useIntl } from 'react-intl';
import { useTranscriptionInteractionsStore } from '../hooks/useTranscriptionInteractionsStore';

const editModeTooltipOnMessage = defineMessage({
  id: 'fragments.transcription.v2.editModeTooltipOn',
  defaultMessage: 'Modo edición: activado',
});

const editModeTooltipOffMessage = defineMessage({
  id: 'fragments.transcription.v2.editModeTooltipOff',
  defaultMessage: 'Modo edición: desactivado',
});

/**
 * Toggles between review mode (word click seeks) and edit mode (word click opens inline editor).
 */
export function TranscriptionEditModeAction() {
  const theme = useTheme();
  const { $t } = useIntl();
  const isEditMode = useTranscriptionInteractionsStore((state) => state.isEditMode);
  const onEditModeClick = useTranscriptionInteractionsStore((state) => state.onEditModeClick);

  const editModeIconButton = (
    <IconButton
      size="small"
      color={isEditMode ? 'success' : 'secondary'}
      sx={{
        bgcolor: isEditMode ? lighten(0.45, theme.palette.success.light) : undefined,
      }}
      onClick={onEditModeClick}
    >
      {isEditMode ? <EditIcon fontSize="small" /> : <EditOffIcon fontSize="small" />}
    </IconButton>
  );

  return (
    <Tooltip
      placement="top"
      title={isEditMode ? $t(editModeTooltipOnMessage) : $t(editModeTooltipOffMessage)}
    >
      {editModeIconButton}
    </Tooltip>
  );
}
